<template>
    <div class="view25Wrapper shadowRadius cardPadding">
        <div class="tipsGlobalText tips" :style="`marginBottom:${tips.length<80?'.6rem':''}`" v-html="newTips"></div>

        <div class="more">
            <RButton color="viewMore" @on-click="()=>onSwitch(true,tips)" v-if="tips.length>80" >
                查看更多
            </RButton>
        </div>
        <CrossSlip>
            <BaseCard v-for="(item,ix) in list" :imgUrl="item.imgUrl" :name="item.title"   @on-click="()=>onAsk(item.title,item.title)" :key="`scene-tips-quick-${ix}`" />
        </CrossSlip>
    </div>
</template>

<script>
    import RButton from '../Use/r-button'
    import CrossSlip from '../Use/cross-slip-wrapper'
    import BaseCard from '../Use/base-card'
    import {mapMutations} from "vuex";

    export default {
        name: "View25",
        components: {RButton, CrossSlip, BaseCard},
        props: {
            list: {
                type: Array,
                default: ()=>[]
            },
            tips: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                isClose:false,
                propsTips: ''
            };

        },
        computed: {
            newTips(){
                let newTips = this.onSilce(this.tips)
                this.propsTips = newTips
                return newTips
            }
        },
        methods: {
            ...mapMutations([
                "setToastContent","setToastShow"
            ]),
            onAsk(name,value) {
                this.$emit('on-ask',name,value)
            },
            onSwitch(value,tips){
                this.setToastShow(true)
                this.setToastContent({toastType: 0,list:{name:'',content:this.propsTips}})
            },
            onSilce(tips){
                let posIndex=[],
                    len=tips.length,
                    pos=0;
                while(pos<len){
                    pos=tips.indexOf('data-w-e="1"',pos);
                    if(pos===-1){//未找到就退出循环完成搜索
                        break;
                    }
                    posIndex.push(pos);//找到就存储索引
                    pos+=1;//并从下个位置开始搜索
                }
                posIndex.map((item, index) => {
                    if(index === 0){
                        tips = tips.slice(0, item+12) + ' class="emoji"' + tips.slice(item+12)
                    }
                    else{
                        tips = tips.slice(0, item+12+14*index) + ' class="emoji"' + tips.slice(item+12+14*index)
                    }

                })
                // console.log(tips)
                return tips;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/common";
    .view25Wrapper {
        /*min-width: 6rem;*/
        /*width: 100%;*/
        width: 8.25rem;
        .tips {
            height: 6em;
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
        }
        .more {
            text-align: center;
            margin-bottom: .5rem;
        }

    }

</style>
